/**
 * The licence count's bounds and its two rules, shared by the placeholder's inline field (flag off)
 * and the purchase dialog (flag on), so the two cannot disagree on what may be bought.
 */
export const MIN_LICENSES = 1;
export const MAX_LICENSES = 999;

/**
 * One predicate covers every bad input: "" -> 0 (below min), "abc" -> NaN,
 * "1.5" -> not an integer, "1e3" -> 1000 (above max).
 */
export const isValidLicenseCount = (count: number) =>
  Number.isInteger(count) && count >= MIN_LICENSES && count <= MAX_LICENSES;

export const clampLicenseCount = (count: number) =>
  Math.min(MAX_LICENSES, Math.max(MIN_LICENSES, Math.trunc(count)));

/**
 * What a typed count becomes on BLUR. Clamping per keystroke rewrites the field out from under
 * someone typing "999". An empty field stays empty, because clamping "" up to 1 fights a user who
 * cleared it to retype, and text that is not a number stays as typed for the caller to refuse.
 */
export function clampLicenseCountOnBlur(value: string): string {
  const raw = value.trim();
  if (!raw) return value;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) return value;
  return String(clampLicenseCount(parsed));
}
